<template>
  <div class="c-text-between px-container c-flex-wrap">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <span class="c-mb-10">FRANKA研究亮点</span>
      <h1>在线研讨会</h1>
      <span class="c-mt-10 c-mb-10 c-text-left text-indent">
        通过我们的网络研讨会系列，探索机器人和人工智能的未来，由Sven Parusel，Franka机器人学术和研究高级副总裁主持。
      </span>
      <span class="c-mt-10 c-text-left text-indent">
        凭借广泛的全球顶级研究人员网络，Sven Parusel汇集了机器人领域的突破性发现和有影响力的见解。每个月，他都会重点介绍一些领先的研究人员，他们在Franka机器人上的工作正在将今天的创新转化为明天的突破。
      </span>
      <!-- <span class="c-mb-10 c-text-left ">
          每个月，他都会重点介绍一些领先的研究人员，他们在Franka机器人上的工作正在将今天的创新转化为明天的突破。
        </span> -->
      <span class="c-mt-10 c-mb-10 c-text-left text-indent">
        加入我们，探索最前沿的进步，并与塑造机器人未来的思想联系起来！
      </span>
    </div>

    <div class="display-width">
      <img src="@/assets/images/webinars/Portrait_Sven_DualArm 4-2.jpg" alt=""
        style="    height: auto; max-width: 100%;">
    </div>
  </div>

  <!-- <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">即将到来的</span>
      <hr class="divider">
    </div>
    
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;"> 
        <h1>即将到来的</h1>
        <h3 class="c-mt-10 c-mb-10 c-text-left ">
          请继续关注即将发布的网络研讨会！
        </h3> 
      </div>
  
      <div class="display-width">
        <img src="@/assets/images/webinars/Portrait_Sven_DualArm 4-2.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div> -->
  <div class="line-with-text px-container">
    <hr class="divider">
    <span class="line-text">最近网络研讨会</span>
    <hr class="divider">
  </div>

  <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px;">
    <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
      <span>2026年2月23日，星期一</span>
      <h1>迈向本地部署的基础行为模型</h1>
      <span style="font-size: 18px;" class="c-mt-5">by Prof. Rudolf Lioutikov</span>
      <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;">
        本次网络研讨会以“迈向本地部署的基础行为模型”为主题，探讨了如何将生成式人工智能领域的最新突破转化为实用、可部署的机器人智能。尽管扩散模型和视觉-语言模型预示着强大且可泛化的机器人行为，但现有方法对于实际应用而言通常过于庞大、缓慢、数据需求量高且涉及隐私问题。在本次研讨会中，鲁道夫·柳蒂科夫教授介绍了近期在大幅缩减模型规模、降低数据需求以及训练与推理成本方面的进展——涵盖了基于得分的扩散模型、视觉-语言-动作模型以及动作标记化——为机器人领域走向高效、保护隐私且可本地部署的基础行为模型描绘了一条清晰的路径。
      </span>
    </div>
    <div class="display-width c-text-both" style="aspect-ratio: 716/450; position: relative;">
      <div style="width: 100%;" class="c-text-both" v-show="!showVideo1">
        <img src="@/assets/images/webinars/Webinar Rudolf Lioutikov.png" style="width: 100%;aspect-ratio: 716/450;" />
        <div class="playButton " @click="showVideo1 = true">
        </div>
      </div>
      <iframe src="https://player.bilibili.com/player.html?bvid=BV1cxNFzPECr" v-if="showVideo1"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
        frameborder="0" scrolling="no" allowfullscreen="true"></iframe>
    </div>
  </div>
  <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px;">
    <!-- <div class="display-width c-text-both">
        <img src="@/assets/images/webinars/Webinar Fei Chen.jpg" alt=""
          style="    height: auto; max-width: 100%;">  
      </div> -->

    <div class="display-width c-text-both" style="aspect-ratio: 716/450; position: relative;">
      <div style="width: 100%;" class="c-text-both" v-show="!showVideo2">
        <img src="@/assets/images/webinars/Webinar Fei Chen.jpg" style="width: 100%;aspect-ratio: 716/450;" />
        <div class="playButton " @click="showVideo2 = true">
        </div>
      </div>
      <iframe src="https://player.bilibili.com/player.html?bvid=BV1s5mCBUEQS" v-if="showVideo2"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
        frameborder="0" scrolling="no" allowfullscreen="true"></iframe>
    </div>
    <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
      <span>星期三，2025年12月10日</span>
      <h1>CURI类人机器人的双手操控与遥操作技术</h1>
      <span style="font-size: 18px;" class="c-mt-5">主讲人：陈翡教授</span>
      <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;">
        陈翡教授是香港中文大学协作与多功能机器人实验室主任，专注于类人机器人双手操控及人机协作研究。在加入港中大之前，他曾于意大利理工学院领导科研工作，并参与多项国际合作项目。陈教授已发表学术成果100余篇，同时积极参与IEEE学术社区活动。
      </span>
      <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;">
        本次讲座中，他展示了CURI类人机器人的双手操控与遥操作技术，探讨先进控制与交互策略如何推动新一代智能多功能机器人系统的发展。
      </span>
    </div>
  </div>
  <!-- <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px;"> 
      <div class="display-width c-text-both">
        <img src="@/assets/images/webinars/Webinar Webpage images (3).jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
        <span>12月11日（星期三）下午5:00 - 6:00</span>
        <h1>通过模块化和规模化解锁机器人的泛化</h1> 
        <span style="font-size: 18px;" class="c-mt-5">by Murtaza Dalal</span>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;"> 
          在最近的网络研讨会上，卡内基梅隆大学即将毕业的博士生Murtaza专注于通过集成模块化和大规模学习来构建多面手机器人系统。
          他解释了如何将模块化规划、学习控制和场景生成相结合，使机器人能够根据文本指令执行复杂的多阶段任务。
          这种方法解决了机器人技术中的关键挑战，如多模态、有限数据和安全问题，推动了机器人能力的极限，以适应各种现实世界的应用。
        </span> 
      </div>  
    </div>  -->
  <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px;">
    <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
      <span>11月14日（周四）下午4:00 - 5:00</span>
      <h1>我们如何理解机器人对物理互动是否安全？</h1>
      <span style="font-size: 18px;" class="c-mt-5">by Robin Jeanne Kirschner</span>
      <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;">
        在我们最新的网络研讨会上，我们与慕尼黑工业大学慕尼黑机器人与机器智能研究所（MIRMI）的
        研究助理Robin Jeanne Kirschner一起分享了她对人机交互中物理和认知安全概念以及评估机器人触觉交互能力的研究见解
        。Robin深入介绍了如何开发数据库来了解人类安全，评估机器人的特性和物理交互的应用程序设计，以确保与环境的安全交互。
      </span>
    </div>
    <div class="display-width c-text-both">
      <img src="@/assets/images/webinars/Webinar Webpage images (1).jpg" alt=""
        style="    height: auto; max-width: 100%;">
      <!-- <div class="playButton ">  
        </div> -->
    </div>
  </div>
  <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px;">
    <div class="display-width c-text-both">
      <img src="@/assets/images/webinars/1.jpg" alt="" style="    height: auto; max-width: 100%;">
      <!-- <div class="playButton ">  
        </div> -->
    </div>
    <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
      <span>9月16日（周一）下午4点</span>
      <h1>面向人机交互的富接触机器人控制框架设计</h1>
      <span style="font-size: 18px;" class="c-mt-5">by Idil Özdamar</span>
      <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;">
        在本次网络研讨会中，来自意大利理工学院人机界面与交互实验室（HRI²）的博士生Idil Özdamar将分享人机交互（HRI）
        的最新进展，并探讨Franka机器人对增强人机协作的影响。讨论还将涵盖这些尖端技术如何以创新和有效的解决方案应对现实世界的挑战。
      </span>
    </div>
  </div>
  <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px;">
    <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
      <span>5月27日（周一）下午4点</span>
      <h1>节俭地学习机器人的操作技巧</h1>
      <span style="font-size: 18px;" class="c-mt-5">by Dr. Sylvain Calinon</span>
      <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;">
        在最近的一次网络研讨会上，伊迪普研究所（Idiap Research Institute）的高级研究科学家、
        EPFL讲师Sylvain Calinon博士分享了他在教授机器人操纵技能方面的专业知识——这种能力对人类来说是天生的
        ，但对机器来说却很复杂。他探讨了机器人如何从有限的训练数据中学习，并强调了开发通用数据和几何结构的重要性，
        以使机器人能够执行广泛的任务。
      </span>
    </div>
    <div class="display-width c-text-both">
      <img src="@/assets/images/webinars/2.jpeg" alt="" style="    height: auto; max-width: 100%;">
      <!-- <div class="playButton ">  
        </div> -->
    </div>
  </div>
  <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px;">
    <div class="display-width c-text-both">
      <img src="@/assets/images/webinars/3.jpg" alt="" style="    height: auto; max-width: 100%;">
      <!-- <div class="playButton ">  
        </div> -->
    </div>
    <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
      <span>4月22日（周一）下午4点</span>
      <h1>机器学习时代的机器人建模与控制</h1>
      <span style="font-size: 18px;" class="c-mt-5">by Dr. Cosimo Della Santina</span>
      <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left;">
        代尔夫特理工大学的科西莫·德拉·桑蒂纳教授（同时担任德意志航天中心的客座科学家）深入探讨了机器人研究中的挑战，
        重点讨论了复杂机械系统的建模与控制。他的报告提供了关于推动机器人技术进步所需的复杂工作的宝贵见解。
      </span>
    </div>
  </div>

</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  metaInfo() {
    return { 
      title: this.$route.meta.title, // 从路由获取标题
      meta: [
        {
          name: 'keywords',
          content: this.$route.meta.metaTags[0]['content']
        }
      ]
    }
  },
  name: 'App',
  components: {
    // HelloWorld
  },
  data() {
    return { 
      showVideo1: false,
      showVideo2: false,

    }
  },
}
</script>

<style scoped>
.display-width {
  width: calc(50% - 40px);
}

@media (max-width: 1029px) {}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .display-width {
    width: 100%
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {}
</style>
<style scoped>
/* h2 {
    font-size: 14px;
    margin-top: 10px;
    color: #333;
  } */
</style>